import React from 'react';

export const faqContentCol1 = [
  {
    accordionTitle: `Are What Car?'s valuations accurate?`,
    childContent: (
      <p>
        {`What Car?'s valuations are provided by Auto Trader, the Uk's number 1 site to buy and sell new and used cars. Their valuation data is based on market supply, real-time consumer demand and live retailer pricing. Its team of editors are constantly reassessing the data to ensure valuations reflect current market conditions.`}
      </p>
    )
  },
  {
    accordionTitle: `What information do I need for a car valuation?`,
    childContent: (
      <p>
        {`To help us provide an accurate valuation, we will need the registration of the car in question and the number of miles it has covered. We will also ask you whether it is in poor, average or excellent condition.`}
      </p>
    )
  },
  {
    accordionTitle: `Do optional extras affect a car's value?`,
    childContent: (
      <p>
        {`Cars fitted with aftermarket accessories, such as non-standard wheels, will often be worth less than those that look like they did when they left the factory. However, you should expect to pay more for high-end models or those that had lots of desirable extra equipment specified by the first owner. `}
      </p>
    )
  },
  {
    accordionTitle: `Why should I get a car valuation?`,
    childContent: (
      <p>
        {`It's important to know the real market value of a car that you're selling so that you can be sure you get a fair price for it. And, similarly, if you're buying, a valuation will help you ensure that you don't pay over the odds.`}
      </p>
    )
  },
  {
    accordionTitle: `How do I find out how much my car is worth?`,
    childContent: (
      <React.Fragment>
        <p>
          {`What Car?’s free valuation tool allows you to quickly and easily find out how much your car is worth. All you need to do is tell us your car’s registration number and mileage, plus a few personal details for us to tell you what it’s worth, whether you’re buying, selling or part-exchanging.`}
        </p>
        <p>
          {`We’ll give you options to tailor the final valuation depending on whether your car is in excellent, average or poor condition.`}
        </p>
      </React.Fragment>
    )
  },
  {
    accordionTitle: `How to find the value of a car for insurance purposes?`,
    childContent: (
      <React.Fragment>
        <p>
          {`Typically, insurance companies will value your car in line with trade prices. These are the prices dealers will expect to pay to buy in new stock, or what you may be offered in a part-exchange deal.`}
        </p>
        <p>
          This means insurance payouts can be significantly less than the price
          you’d pay if you were buying the car. If this is a concern, it’s worth
          considering insurance policies with new-for-old cover, or for certain
          models, an agreed value. For newer cars,{' '}
          <a href="https://www.whatcar.com/advice/buying/what-is-gap-insurance-and-how-much-should-you-pay-for-it/n1183">
            GAP insurance
          </a>{' '}
          cover can be reassuring.
        </p>
      </React.Fragment>
    )
  },
  {
    accordionTitle: `Is a What Car? valuation accurate?`,
    childContent: (
      <React.Fragment>
        <p>
          {`What Car?’s valuations are based on the same data used by thousands of car dealers and insurance companies across the UK. This means the values provided are consistent with cars you’ll see for sale on classified websites, and what you can expect to receive from a dealer if you part-exchange.`}
        </p>
        <p>
          {`However, there are factors that aren’t taken into account, such as optional extras, how much service history your car has and the length of the MOT.`}
        </p>
      </React.Fragment>
    )
  },
  {
    accordionTitle: `How can a What Car? valuation help you?`,
    childContent: (
      <React.Fragment>
        <p>
          {`If you’re buying a new car or selling your old one, you’ll need to know how much it’s worth – and that’s where What Car?’s valuation steps in.`}
        </p>
        <p>
          {`For car buyers, it’s a valuable tool to see how much they should be paying, be that at a dealership or from a private seller. Our valuations also show you how much you can expect a dealer to pay should you be part-exchanging your car. Having an idea of your car’s part-ex value before you start negotiating can help you better understand what you can afford.`}
        </p>
        <p>
          {`Similarly, if you’re selling your car, our car valuation calculator can show you at a glance the kind of money you can expect to receive if you sell privately. It provides a great indication of how you should price your car. You can then factor the prices of other similar cars for sale locally, and how much you can expect to be haggled down by.`}
        </p>
      </React.Fragment>
    )
  },
  {
    accordionTitle: `Can I get a free car valuation without email?`,
    childContent: (
      <p>
        {`No, you need to register for a What Car? valuation, but it’s free and only takes a moment. These simple steps are in order for us to email your valuation to you, and you can opt out of promotions and other services by ticking the appropriate boxes.`}
      </p>
    )
  },
  {
    accordionTitle: `How does the What Car?'s car value calculator work?`,
    childContent: (
      <p>
        {`What Car?’s car valuation calculator uses widely-used car pricing data provided by specialists that supply prices across the car industry. It means our valuations are representative of what you can expect to see on dealer forecourts and in used-car classifieds across the country.`}
      </p>
    )
  },
  {
    accordionTitle: `Can I value more than one car?`,
    childContent: (
      <p>
        {`In order to prevent abuse of our free system, we allow up to 20 used car valuations a month.`}
      </p>
    )
  },
  {
    accordionTitle: `How far back does What Car?'s data go, and what are the earliest plates you cover?`,
    childContent: (
      <p>
        {`What Car?’s car valuation tool can price cars dating back to 1998, meaning the earliest cars we can value will be on an ‘S’-plate.`}
      </p>
    )
  },
  {
    accordionTitle: `What is included in the report when I value my car?`,
    childContent: (
      <React.Fragment>
        <p>
          {`Based on the details you provide, we’re able to provide valuations for your car in poor, average or excellent condition, taking into account your vehicle’s age and mileage. This makes it easier for you to get a more precise valuation.`}
        </p>
        <p>
          {`Additionally, depending on your circumstances, we provide you with specific prices should you be buying or selling privately or part-exchanging your car.`}
        </p>
      </React.Fragment>
    )
  },
  {
    accordionTitle: `What can reduce a car's value?`,
    childContent: (
      <React.Fragment>
        <p>
          {`There are many factors that can reduce your car’s value, but the key ones to consider are age, mileage and general condition.`}
        </p>
        <p>
          {`There’s little you can do about age and mileage, but it’s important to present your car in the best light when the time comes to sell. That means giving it a good wash inside and out, gathering together all the service history and, if it makes financial sense to do so, getting it serviced and put through an MOT test if one is due.`}
        </p>
        <p>
          {`Modifications can boost the appeal and value of certain kinds of car, such as performance models, but can harm the value of other cars. If your car has non-standard wheels, a body kit, stickers or audio system, consider returning the car to its original condition.`}
        </p>
      </React.Fragment>
    )
  },
  {
    accordionTitle: `How do we value your car?`,
    childContent: (
      <React.Fragment>
        <p>
          {`What Car?’s valuation calculator uses your vehicle’s registration number to ascertain the make, model, engine, trim and colour, and supplements this with the mileage you provide. These details are then matched with the continually updated pricing information we hold.`}
        </p>
        <p>
          {`This data is provided to us by one of the UK’s most respected car pricing specialists, which works alongside a range of industry experts and motorists to provide values.`}
        </p>
      </React.Fragment>
    )
  },
  {
    accordionTitle: `What is car depreciation?`,
    childContent: (
      <p>
        {`Depreciation refers to the value a car loses over time: the difference between what you pay for the car and its value when you come to sell. Depreciation is usually expressed as a percentage based on a car covering 12,000 miles a year over three, and assumes the car is maintained and in reasonable condition.`}
      </p>
    )
  },
  {
    accordionTitle: `How long does a car valuation take?`,
    childContent: (
      <p>
        {`A What Car? valuation takes seconds once you’ve entered your car’s registration plate and mileage, plus some personal details. You’ll be able to view your valuation immediately afterwards, and you’ll receive an email confirmation shortly afterwards.`}
      </p>
    )
  }
];



// WEBPACK FOOTER //
// ./src/components/FAQs/faqContent.js